/* ============================================================================
   NeoSpherium — wake lazy images when a PRERENDERED page activates.

   THE BUG THIS FIXES
   ns-speculation-rules.liquid prerenders every /products/*, /collections/* and
   District page after ~200ms of hover. A prerendered document has NO VISIBLE
   VIEWPORT, so the browser cannot judge which loading="lazy" images are near
   the fold and defers ALL of them. On click the page activates instantly with
   those images still unfetched, and the visitor sees blank tiles or alt text
   until something forces a refetch. A refresh "fixes" it only because a
   refreshed page was never prerendered. 79 lazy images across 37 templates are
   exposed to this, which is why it reads as a whole-site fault.

   THE FIX
   On activation, promote to eager every lazy image that is unloaded and sits
   within two viewports of the fold. Setting img.loading = 'eager' on an
   unloaded image starts the fetch immediately. Images further down stay lazy,
   so nothing below the fold is fetched early and the bandwidth saving is kept.

   SAFE BY DESIGN
     - does nothing on an ordinary navigation: it returns unless the document
       was actually prerendered.
     - does nothing on browsers without the API (Safari, Firefox), which never
       prerender in the first place.
     - never touches an image that has already loaded.
     - no layout change, no markup change, no new request for anything the page
       would not have fetched a moment later anyway.
   Reversible: delete this file and its script line in layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  /* Browsers without prerendering never hit the bug. */
  if (!('prerendering' in document)) return;

  var VIEWPORTS_AHEAD = 2;

  function wake() {
    var vh = window.innerHeight || 800;
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    var woken = 0;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete && img.naturalWidth > 0) continue;   /* already loaded */
      var r = img.getBoundingClientRect();
      if (r.bottom < 0) continue;                           /* scrolled past */
      if (r.top > vh * VIEWPORTS_AHEAD) continue;           /* far below: stays lazy */
      img.loading = 'eager';
      woken++;
    }
    if (window.NS_DEBUG) console.info('[ns-prerender-images] woke ' + woken + ' image(s)');
    return woken;
  }

  if (document.prerendering) {
    /* still prerendering: wake them the moment this document is activated */
    document.addEventListener('prerenderingchange', wake, { once: true });
  } else {
    /* already activated before this deferred file ran. activationStart is
       non-zero only for a document that was prerendered, so this is the
       catch-up path for a fast activation and never fires on a normal load. */
    var nav = performance.getEntriesByType('navigation')[0];
    if (nav && nav.activationStart > 0) wake();
  }
})();
